import { ActionReducerMapBuilder, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { JoinChannelTasksDto } from "../../pages/TaskPage/Tasks/JoinChannelTask/JoinChannelTaskPage";
import { IRequestState } from "../request.state.interface";
import { VkShareTaskDto } from "../../pages/TaskPage/Tasks/VkShareTask/VkShareTask";
import getTasksHandler, { HomescreenShortcutTaskDto, QuizTaskDto } from "./get-tasks.handler";
import checkJoinTasksHandler from "./check-join-channel.handler";
import performVkShareTaskHandler from "./perform-vk-share.handler";
import checkVkShareTaskHandler from "./check-vk-share.handler";
import setHomescreenShortcutTaskHandler from "./set-homescreen-shortcut.handler";
import viewJoinTasksHandler from "./view-join-channel.handler";

export interface ITasksState extends IRequestState {
    joinChannelTasks: JoinChannelTasksDto | null;
    vkShareTasks: VkShareTaskDto[],
    quizTask: QuizTaskDto | null,
    homescreenShortcutTask: HomescreenShortcutTaskDto | null;

    referalsCount: number;
    referalReward: number;
    interestsCount: number;
};

const initialState: ITasksState = {
    joinChannelTasks: null,
    vkShareTasks: [],
    quizTask: null,
    homescreenShortcutTask: null,

    referalsCount: 0,
    referalReward: 0,
    interestsCount: 0,

    loading: false,
    error: "",
};

const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        tasksClearError: (state: Draft<ITasksState>) => {
            state.error = "";
        },
        setQuizTaskAllowDate: (state: Draft<ITasksState>, action: PayloadAction<number>) => {
            if (state.quizTask)
                state.quizTask.allowDate = action.payload;
            else
                state.quizTask = { allowDate: action.payload };
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<ITasksState>) => {
        getTasksHandler(builder);
        checkJoinTasksHandler(builder);
        viewJoinTasksHandler(builder);
        performVkShareTaskHandler(builder);
        checkVkShareTaskHandler(builder);
        setHomescreenShortcutTaskHandler(builder);
    },
});

export const { tasksClearError, setQuizTaskAllowDate } = tasksSlice.actions;
export default tasksSlice.reducer;